/**
 * Transform character deep-dive relationships into react-force-graph-2d graph data.
 * @param {string} centerName - The focal character's name
 * @param {Array} relationships - [{ name, type, dynamic, scenes }]
 * @returns {{ nodes: Array, links: Array }}
 */
export function buildRelationshipGraph(centerName, relationships = []) {
  const center = (centerName || 'Character').trim() || 'Character';
  const nodes = [{ id: center, name: center, isCenter: true }];
  const links = [];
  const seen = new Set([center.toLowerCase()]);

  (relationships || []).forEach((rel, index) => {
    const name = (rel?.name || `Character ${index + 1}`).trim();
    if (!name) return;
    const key = name.toLowerCase();
    if (!seen.has(key)) {
      seen.add(key);
      nodes.push({ id: name, name, isCenter: false });
    }
    links.push({
      source: center,
      target: name,
      type: rel?.type || 'other',
      dynamic: rel?.dynamic || '',
    });
  });

  return { nodes, links };
}

export default buildRelationshipGraph;
